export default {
  debug(...args: any[]) {
    const debug = import.meta.env.DEV || window.BOTBRAINS_DEBUG || (new URLSearchParams(window.location.search)).has("botbrainsDebug");
    if (debug) {
      console.log(...args);
    }
  },
};
